import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import Loader from './Loader';
import { CURRENCIES } from '../constants/currencies';
import { T } from '../stores/textStore';

class CartListDynamic extends Component {

    renderListings() {
        const listings = [];
        const { cart } = this.props.shopStore;
        const hc = cart.get('hypoCashsale');    
        const currency = CURRENCIES[hc.currencysymbol.toLowerCase()];
        if (hc && hc.lineitems && hc.lineitems.length) {
            hc.lineitems.map(lineItem => {            
                listings.push(
                    <li key={lineItem.item} className="list-group-item d-flex justify-content-between lh-condensed">
                        <div className={lineItem.itemtype === 'Discount' ? 'text-success' : ''}>                             
                            <h6 className="my-0">
                                {lineItem.description} 
                                {/*lineItem.quantity &&
                                    <small>&nbsp; | Quantity: {lineItem.quantity}</small>
                                */}
                            </h6>
                            <small className={lineItem.itemtype === 'Discount' ? 'text-success' : 'text-muted'}>
                                {lineItem.itemname === 'EVENTBRITE DONATION TICKET' ? 'DONATION' : lineItem.itemname}
                            </small>
                        </div>
                        <span className={lineItem.itemtype === 'Discount' ? 'text-success' : 'text-muted'}>
                            {currency.symbol}{lineItem.amount}
                        </span>
                    </li>                
                )
                return null;
            });   
        } else {
            listings.push(
                <li key="emptyCartKey" className="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                        <h6 className="my-0 text-muted">Your cart is empty.</h6>                        
                    </div>                    
                </li>                
            )            
        }
        return listings;
    }

	handleCouponChange = (event) => {
        event.preventDefault();
        const { cart } = this.props.shopStore;   
        cart.set('coupon', event.target.value);
    }

	handleCouponSubmit = (event) => {
        event.preventDefault();
        const { shopStore } = this.props;
        const { cart } = shopStore;  
        /*if (!cart.get('coupon')) {
            return;
        }*/
        shopStore.fetchHypoCashsale();
    }    
    
    renderCouponForm() {
        const { cart } = this.props.shopStore;    
        const hc = cart.get('hypoCashsale'); 
        if (!hc || !hc.lineitems || (hc.lineitems.length === 0)) {
            return null;
        }
        return (
            <form className="card p-2 bg-success border-secondary">
                <div className="input-group">
                    <input 				
                        type="text" 
                        className="form-control border-secondary"
                        name='coupon' 
                        placeholder="Promo code" 
                        value={cart.get('coupon')} 
                        onChange={this.handleCouponChange}
                    />
                    <div className="input-group-append">
                        <button 
                            type="submit" 
                            className="btn btn-secondary" 
                            onClick={this.handleCouponSubmit}																						
                        >
                            Apply              
                        </button> 
                    </div>
                </div>
            </form>            
        );     
    }

    render() {
        const { shopStore } = this.props;
        const { cart } = this.props.shopStore;
        const hc = cart.get('hypoCashsale');   
        if (shopStore.processingCart.get()) {
            return <span>{T('Loading your cart...')} <Loader /></span>
        }
        const currency = CURRENCIES[hc.currencysymbol.toLowerCase()];
        return (
            <span>                
                <h4 className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">{T('Your Cart')}</span>
                    <span className="badge badge-secondary badge-pill">
                        {cart.get('items') ? cart.get('items').length : 0}
                    </span>
                </h4>
                <ul className="list-group mb-3">
                    {this.renderListings()}
                    <li className="list-group-item d-flex justify-content-between">
                        <span>{T('Total')} ({hc ? hc.currencysymbol: ''})</span>
                        <strong>{currency.symbol}{hc ? hc.total: '0.00'}</strong>
                    </li>
                </ul>  
                <div>{shopStore.enableCoupons && this.renderCouponForm()}</div>
            </span>
        );
    }

}

export default inject('shopStore')(observer(CartListDynamic));



// WEBPACK FOOTER //
// ./src/components/CartListDynamic.js